// /src/core/utils/reportUtils.js
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Utility function to generate table headers
const generateTableHeaders = (columns) => {
  return columns
    ?.map((col) => col.title)
    .filter((header) => header !== "Actions" && header !== "Sl No");
};

// Detect and sort by code-like field (GR1, PI10, etc.)
const smartSort = (data = []) => {
  if (!data?.length) return data;

  // Try to detect key for sorting
  const possibleKeys = [
    "billNo",
    "entrynumber",
    "no",
  ];

  const key = possibleKeys.find((k) => k in data[0]) || "no";

  const sorted = [...data].sort((a, b) => {
    const strA = a[key]?.toString() || "";
    const strB = b[key]?.toString() || "";

    const prefixA = strA.match(/[A-Za-z]+/)?.[0]?.toLowerCase() || "";
    const prefixB = strB.match(/[A-Za-z]+/)?.[0]?.toLowerCase() || "";

    const numA = parseInt(strA.match(/\d+/)?.[0]) || 0;
    const numB = parseInt(strB.match(/\d+/)?.[0]) || 0;

    if (prefixA !== prefixB) return prefixA.localeCompare(prefixB);
    return numA - numB;
  });

  return sorted;
};

// Utility function to generate table body rows
const generateTableBody = (data, tableHeaders, fieldMapping) => {
  return data?.map((item) => {
    return tableHeaders?.map((header) => {
      const field = fieldMapping[header];
      let value = field?.includes(".")
        ? field.split(".").reduce((obj, key) => obj && obj[key], item)
        : item[field];
      if (header === "Invoice Date") {
        console.log();
      }
      if (header.toLowerCase()?.includes("date") && value) {
        value = dayjs(value).format("DD-MM-YY");
      }

      if (field === "products") {
        value = item?.product?.name;
      }
      if (field === "units") {
        value = item?.unit?.name;
      }
      if (field === "salesPaymentType") {
        switch (value) {
          case 0:
            value = "Cash";
            break;
          case 1:
            value = "Credit";
            break;
          case 2:
            value = "UPI";
            break;
          case 3:
            value = "Card";
            break;
          default:
            value = "Unknown";
        }
      }
      if (field === "purchasePaymentType") {
        switch (value) {
          case 0:
            value = "Cash";
            break;
          case 3:
            value = "Credit";
            break;
          case 4:
            value = "UPI";
            break;
          case 1:
            value = "Card";
            break;
            case 2:
            value = "Bank";
            break;
          default:
            value = "Unknown";
        }
      }
      if (field === "type") {
        switch (value) {
          case 0:
            value = "Stock Adjustment";
            break;
          case 1:
            value = "Damage";
            break;
          case 2:
            value = "Wastage";
            break;
          default:
            value = "Unknown";
        }
      }

      return value;
    });
  });
};

// Excel Export
export const exportExcel = (getActiveTabData) => {
  const { data, columns, fieldMapping,Rname} = getActiveTabData();
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping);

  const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  XLSX.writeFile(workbook, `${Rname}.xlsx`);
};

// Printable format
export const printReport = (getActiveTabData) => {
  const { data, columns, fieldMapping,Rname } = getActiveTabData();

  const printWindow = window.open("", "_blank");

  // Prepare the document for printing
  printWindow.document.write("<html><head><title>Print Report</title>");
  printWindow.document.write("<style>");
  printWindow.document.write(`
        table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
        }
        th {
            background-color: #f2f2f2;
        }
    `);
  printWindow.document.write("</style></head><body>");
  printWindow.document.write(`<h1>${Rname}</h1>`);

  const tableHeaders = generateTableHeaders(columns);
  let tableHTML = "<table><thead><tr>";
  tableHeaders.forEach((header) => {
    tableHTML += `<th>${header}</th>`;
  });
  tableHTML += "</tr></thead><tbody>";

  const tableBody = generateTableBody(data, tableHeaders, fieldMapping);
  tableBody.forEach((row) => {
    tableHTML += "<tr>";
    row.forEach((cell) => {
      tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`;
    });
    tableHTML += "</tr>";
  });
  tableHTML += "</tbody></table>";

  printWindow.document.write(tableHTML);
  printWindow.document.write("</body></html>");

  printWindow.document.close();
  printWindow.print();
};

// PDF Export
// export const exportPDF = (getActiveTabData,companyInfolist ) => {
//   const { data, columns, fieldMapping ,Rname} = getActiveTabData();

//   // Set orientation based on the number of columns (e.g., more than 5 columns -> landscape)
//   const orientation = columns?.length > 9 ? "landscape" : "portrait";

//   const company = companyInfolist.length > 0 ? companyInfolist[0] : {}; // Assuming single company info
//   const companyName = company?.name || "Company Name"; // Fallback if name is not available

  
//   // Initialize jsPDF with the dynamic orientation
//   const doc = new jsPDF({
//     orientation: orientation,
//   });

//   // Generate table headers and body
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping);
//   const marginTop = 30; // Margin from the top of the page
//   doc.setFontSize(16);
//   doc.text(companyName, 14, 15); // Title at the top

// console.log(companyName,"companyName");
// console.log
//   // Use autoTable to export the table
//   autoTable(doc, {
//     startY: marginTop + 20, // Moves the table down
//     head: [tableHeaders],
//     body: tableBody,
//   });

//   // Save the PDF
//   doc.save(`${Rname}.pdf`);
// };
export const exportPDF = (getActiveTabData, companyInfolist) => {
  const { data, columns, fieldMapping, Rname } = getActiveTabData();

const sortedData = smartSort(data);


  const orientation = columns?.length > 9 ? "landscape" : "portrait";

  const company = companyInfolist.length > 0 ? companyInfolist[0] : {};
  const companyName = company?.name || "Company Name";

  const doc = new jsPDF({ orientation });
  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(sortedData, tableHeaders, fieldMapping);

  doc.setFontSize(16);
  doc.text(companyName, 14, 15);

  autoTable(doc, {
    startY: 40,
    head: [tableHeaders],
    body: tableBody,
  });

  doc.save(`${Rname}.pdf`);
};
